class AddToCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onAdd);
  }
  onAdd() {
    this.classList.add('loading');
    var variantId = this.getAttribute('data-variant-id');
    var quantity = this.getAttribute('data-quantity');
    const cartDrawer = document.querySelector('cart-drawer');

    const body = {
      id: variantId,
      quantity: quantity ? quantity : 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.classList.remove('loading');
        
        if (data.status && data.status >= 400) {
          alert(data.description || 'Could not add item. Please try again.');
          return;
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else if (window.__awCartRefresh) {
          window.__awCartRefresh(data);
        } else {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        this.classList.remove('loading');
      });
  }
}
customElements.define('add-to-cart', AddToCart);
